import React from 'react';
import * as styles from '../styles/statusLine.module.scss';

interface Props {
  text: string;
  title: string;
  error: boolean;
  icon: JSX.Element;
}

const StatusLine: React.FC<Props> = ({ text, title, error, icon }) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <div className={styles.line}></div>
        <div className={error ? styles.icon_error : styles.icon} title={title}>
          {icon}
        </div>
        <div className={styles.time}>{text}</div>
      </div>
    </div>
  );
};

export default StatusLine;
